import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


const __default__ = {
    name: "OperatorApplicationSideMenuItem"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    selected: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {



let emits = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({'side-menu-item': true, selected: __props.selected}),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('click')))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})